import { toast } from "react-toastify";
import StyledHeadingText from "../../components/Fonts/StyledHeadingText";
import { patchOrderPayment } from "../../services/orders";
import Button from "../../components/buttons/Button";
import { useEffect, useState } from "react";
import { deleteForumMessage, getForumChats, sendForumMessage } from "../../services/forum";
import ChatCard from "../../components/ChatCard";
import { getUserId } from "../../helpers/local_storage_helpers";
import CustomLoading from "../../components/customLoading/CustomLoading";
import { BsFillEmojiGrinFill } from "react-icons/bs";
import ShowModal from "../../utils/ShowModal";
import EmojiPicker from "emoji-picker-react";
import GalleryComponent from "../../components/GalleryComponent";

function ForumPopView({ item }) {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [message, setMessage] = useState("");
    const [showEmogies, setShowEmogies] = useState(false);

    const onEmogiesChange = (emogi) => {
        const newMessage = message + emogi.emoji;
        setMessage(newMessage);
    };

    const fetchData = async (id) => {
        setLoading(true);
        try {
            let res = await getForumChats(id);
            if (res.status === 200) {
                setData(res.data);
            } else {
                toast.error("Unable to fetch Data");
            }
        } catch (error) {
            console.error("Error fetching Data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (item?.id) {
            fetchData(item.id);
        }
    }, [item.id]);

    const sendMessage = async () => {
        if (message.trim()) {
            const newMessage = {
                forum: item.id,
                user: "5",
                comment: message,
            };
            try {
                let res = await sendForumMessage(newMessage);
                if (res.status === 201) {
                    fetchData(item.id);
                    setMessage("");
                } else {
                    toast.error("Unable to send Message");
                }
                setLoading(false);
            } catch (error) {
                console.error("Error sending Message:", error);
            }
        }
    };

    const deleteMessage = async (chatId) => {
        try {
            let res = await deleteForumMessage(chatId);
            if (res.status === 204) {
                fetchData(item.id);
                toast.success("Message delete successfully");
            } else {
                toast.error("Unable to delete Message");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error deleting Message:", error);
        }
    };

    return (
        <div className="w-full h-full flex flex-col bg-gray-100 border rounded-lg shadow-lg mt-2">
            {/* Header */}
            <div className="p-4 border-b bg-white">
                <StyledHeadingText text={`Forum Details: ${item.commodity_name} | ${item.user}`} />
                <p className="mb-1">{`Que: ${item.question}`}</p>
                <p className="mb-1">{`${item.description}`}</p>
                <StyledHeadingText text={`Images`} size={"text-sm mb-2"} />
                <GalleryComponent openingComponent={
                    <div className="w-full flex flex-row gap-4 justify-start overflow-x-auto bg-slate-200 rounded">
                        {item.images ? item.images.map((e, i) => (<img src={e} className="aspect-square max-w-24 rounded object-cover" />)) : <></>}
                    </div>
                } images={item.images || []} />
            </div>

            {/* Chat Container */}
            <div className="flex-1 overflow-y-auto p-4 space-y-3 max-h-[20rem]">
                {loading ? (
                    <CustomLoading />
                ) : data.length > 0 ? (
                    data.map((chat) => (
                        <ChatCard
                            key={chat.comment_id}
                            chat={chat}
                            currentUserId={parseInt(getUserId())}
                            onMessageDelete={(id) => deleteMessage(id)}
                        />
                    ))
                ) : (
                    <p className="text-gray-500 text-center mt-4">No chats available.</p>
                )}
            </div>

            {/* Message Input */}
            <div className="p-4 border-t bg-white flex items-center">
                <button
                    className="mr-2 p-2 bg-gray-200 rounded-full"
                    onClick={() => setShowEmogies(!showEmogies)}
                >
                    <BsFillEmojiGrinFill className="text-gray-600" size={24} />
                </button>
                <textarea
                    className="flex-1 p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-400"
                    onChange={(e) => setMessage(e.target.value)}
                    value={message}
                    placeholder="Type a message..."
                    rows="1"
                ></textarea>
                <button
                    className="ml-2 px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition"
                    onClick={sendMessage}
                >
                    Send
                </button>
            </div>

            {/* Emoji Picker */}
            {showEmogies && (
                <ShowModal
                    componentToPass={<EmojiPicker onEmojiClick={(e) => setMessage((prev) => prev + e.emoji)} />}
                    contentLabel={"Emoji Keyboard"}
                    isOpen={showEmogies}
                    modalWidth={"25rem"}
                    onRequestClose={() => setShowEmogies(false)}
                />
            )}
        </div>
    );
}

export default ForumPopView;
